<div class="list-group-item d-flex lh-1 h-100">
  <div class="align-middle">
    Name<br />
    <small class="font-monospace">Serialnumber</small>
    <fa-icon [icon]="['fas', 'filter']"
             class="ms-1"
             #serialNumberFilter
             (click)="onSerialNumberFilterClicked()"></fa-icon>
  </div>
  <div class="ms-auto px-3 text-end text-nowrap">
    <br />
    <small>Last seen</small>
  </div>
</div>